import { Injectable } from '@angular/core';
import {BaseServiceContextService} from "./base-service-context.service";
import {Params} from "../models/params";
import {Pageable} from "../models/pageable";
import {HttpParams} from "@angular/common/http";
import {VirtualDevice} from "../../main/device/device.model";

@Injectable({
  providedIn: 'root'
})
export class VirtualDevicesService {

  constructor(private baseServiceContext: BaseServiceContextService) { }


  fetchData(form: any) : Promise<VirtualDevice[] | undefined> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('event', form?.event!);
    return this.baseServiceContext.http
      .get<VirtualDevice[] | undefined>(`${this.baseServiceContext.baseUrl}/virtual-devices/`, {params: queryParams})
      .toPromise();
  }
  getById(id: number){
    return this.baseServiceContext.http
      .get<VirtualDevice | undefined>(`${this.baseServiceContext.baseUrl}/virtual-devices/${id}/`,)
      .toPromise();
  }

  create(form: VirtualDevice) : Promise<VirtualDevice | undefined> {
    return this.baseServiceContext.http
      .post<VirtualDevice | undefined>(`${this.baseServiceContext.baseUrl}/virtual-devices/`, form)
      .toPromise();
  }

  edit(form: VirtualDevice) : Promise<VirtualDevice | undefined> {
    return this.baseServiceContext.http
      .put<VirtualDevice | undefined>(`${this.baseServiceContext.baseUrl}/virtual-devices/${form?.id}/`, form)
      .toPromise();
  }

  delete(id: number) : Promise<VirtualDevice | undefined> {
    return this.baseServiceContext.http
      .delete<VirtualDevice | undefined>(`${this.baseServiceContext.baseUrl}/virtual-devices/${id}/`)
      .toPromise();
  }


}
